import * as React from 'react';
import { DialogContent, DialogTitle, Dialog, Divider } from '@mui/material';
import { Button } from '@mui/material';
import { Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import { useState } from 'react';
import { HelpOutline } from '@mui/icons-material';
import styles from './InformationButton.module.scss';


interface TypeProps {
    gutterbottom?: boolean;
    onClose?: () => void;
    children: any;
}

const TypographyStyle = styled(Typography)<TypeProps>(({theme, gutterbottom}) => ({
    marginBottom: gutterbottom ? theme.spacing(2) : 0,
}))



// Styling for the Dialog Box
const InformationDialogStyle = styled(Dialog)(({theme}) => ({
    "& .MuiDialog-container": {
        justifyContent: "flex-end",
        alignItems: "flex-start",
        marginTop: theme.spacing(5),
      },
    "& .MuiDialogContent-root": {
        padding: theme.spacing(2),
        alignItems: 'flex-start',
        textAlign: 'center'
      },
      "& .MuiDialogActions-root": {
        padding: theme.spacing(1),
      }
}))

const InformationDialog = (props: { [x: string]: any; children: any; onClose: any; }) => {
    const { children, onClose, ...other} = props;

    return (
        <DialogTitle 
        style={{position: 'relative',
        display: 'flex',
        justifyContent: 'center',}} 
        {...other}>
            {children}
        </DialogTitle>
    )
}

export default function InformationButton() {
    const [open, setOpen] = useState(false);
    const handleClickOpen = () => {
        setOpen(true);
    };
    const handleClose = () => {
        setOpen(false);
    };
    return(
        <div>
        <Button className={styles.Button} onClick={handleClickOpen} >
            <HelpOutline className={styles.Icon}/>
        </Button>
        
        <InformationDialogStyle
        onClose={handleClose}
        open={open}
        >
            <InformationDialog
            onClose={handleClose}
            open={open}
            >
                <h3 style={{margin: '0.1rem'}}> Welcome to OPUS!</h3>
            </InformationDialog>
            <DialogContent dividers>
                <Typography>
                The guide for legal and regulatory resource information!
                </Typography>
                <TypographyStyle gutterbottom style={{color:'red'}}>
                FOR INTERNAL USE ONLY!
                </TypographyStyle>
                <br/>
                <Divider />
                <br/>
                <TypographyStyle gutterbottom>
                A compilation of statues, regulation and case law on a range of topics of interest across MagMutual. OPUS provides succinct summaries and direct quotations from source material (along with citations to authority) for all 50 states and the District of Columbia on each topic in a collated and easily navigated database.
                </TypographyStyle>
                <br/>
                <TypographyStyle gutterbottom>
                This database is managed and maintained by the Legal Team. We welcome your feedback!
                </TypographyStyle>
            </DialogContent>
        </InformationDialogStyle>
        </div>
    )
}
